export default "__VITE_ASSET__6553a577__"